// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { USER_ACCESS_URL, USER_ACCESS_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { UserAccessIndex } = lazily(() => import('pages/back-office/user-access'))

const userAccessIndexRoutes: IRoute[] = [
  {
    path: USER_ACCESS_URL.INDEX,
    component: UserAccessIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_ACCESS_MODULE,
      requireAuth: true,
      attrs: {
        label: 'masterUserAccess.userAccess',
        accessCodes: [1002],
      },
    },
  },
]

export { userAccessIndexRoutes }
